import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "../../lib/cx";
import styles from "./Card.module.css";

export type CardVariant = "plain" | "gradient";

export type CardProps = {
  variant?: CardVariant;
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export const Card = ({ variant = "plain", className, children, ...rest }: CardProps) => (
  <div data-variant={variant} className={cx(styles.card, className)} {...rest}>
    {children}
  </div>
);
